import { TOGGLE_NAV_DRAWER } from '../actions'

const isNavDrawerOpen = (state = false, action) => {
    switch (action.type) {
        case TOGGLE_NAV_DRAWER:
            return (typeof action.isOpen === 'undefined') ? !state : action.isOpen
        default:
            return state
    }
}

export default isNavDrawerOpen


// WEBPACK FOOTER //
// ./src/reducers/isNavDrawerOpen.js